var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Music"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M5 4.16667H15",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M6.66699 1.66667H13.3337",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5337 18.3334H3.46699C2.47283 18.3334 1.66699 17.5276 1.66699 16.5334V8.46675C1.66699 7.47258 2.47283 6.66675 3.46699 6.66675H16.5337C17.5278 6.66675 18.3337 7.47258 18.3337 8.46675V16.5334C18.3337 17.5276 17.5278 18.3334 16.5337 18.3334Z",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M8.17587 14.0011C8.66403 14.4893 8.66403 15.2807 8.17587 15.7689C7.68772 16.257 6.89627 16.257 6.40811 15.7689C5.91995 15.2807 5.91995 14.4893 6.40811 14.0011C6.89626 13.513 7.68772 13.513 8.17587 14.0011",
    stroke: "#F2EBEF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M12.7589 13.1676C13.247 13.6558 13.247 14.4472 12.7589 14.9354C12.2707 15.4236 11.4793 15.4236 10.9911 14.9354C10.503 14.4472 10.503 13.6558 10.9911 13.1676C11.4793 12.6795 12.2707 12.6795 12.7589 13.1676",
    stroke: "#F2EBEF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M8.54199 14.8849V10.8657C8.54199 10.5249 8.74949 10.2182 9.06616 10.0924L11.9828 8.92574C12.5303 8.70657 13.1253 9.10991 13.1253 9.69907V14.0516",
    stroke: "#F2EBEF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/Music.6782439c21890ee25f7bb8c779e50917.svg";
export { ForwardRef as ReactComponent };